import { render } from "./TissGuideModal.vue?vue&type=template&id=db398338&scoped=true"
import script from "./TissGuideModal.vue?vue&type=script&lang=js"
export * from "./TissGuideModal.vue?vue&type=script&lang=js"

import "./TissGuideModal.vue?vue&type=style&index=0&id=db398338&scoped=true&lang=css"
import "./TissGuideModal.vue?vue&type=style&index=1&id=db398338&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db398338"]])

export default __exports__